import {useState} from 'preact/hooks';
import {TextField} from '@ultradent/components';
import Icon from '@components/common/Icon';

const PasswordShowHide = ( {handleChange, value, errors} ) => {

    const [hidden, setHidden] = useState( true );
    const handleHiddenChange = () => setHidden( !hidden );

    return (
        <TextField
            label="Password*"
            type={hidden ? 'password' : 'text'}
            name="password"
            value={value}
            debounceOnChange={true}
            append={
                <Icon.ui
                    center
                    data-tooltip={`${hidden ? 'Show password' : 'Hide password'}`}
                    className="text-xl"
                    name={`${hidden ? 'eye-open' : 'eye-closed'}`}
                    onClick={handleHiddenChange}/>}
            onChange={handleChange}
            error={errors.password}
            id="password"/>
    );
}

export default PasswordShowHide;
